import { render, staticRenderFns } from "./AnnounceIndex.vue?vue&type=template&id=1ded3abe&scoped=true&"
import script from "./AnnounceIndex.vue?vue&type=script&lang=js&"
export * from "./AnnounceIndex.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceIndex.vue?vue&type=style&index=0&id=1ded3abe&prod&scoped=true&lang=css&"
import style1 from "./AnnounceIndex.vue?vue&type=style&index=1&id=1ded3abe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded3abe",
  null
  
)

export default component.exports